module.exports = __webpack_public_path__ + "static/media/apple_logo_purple_dark.bd63400c.svg";